import React from 'react'
import { toast } from 'sonner'
import ReactDOM from 'react-dom/client'

import './styles/shadcn.css'
import './styles/global.css'

import SWUpdateNotification from '@/components/SWUpdateNotification'
import { RouterProvider } from '@/router'

import routes from './routes'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import './i18n'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <RouterProvider value={routes}></RouterProvider>
  </React.StrictMode>,
)

if (import.meta.env.VITE_USE_SW === 'true') {
  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://cra.link/PWA
  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      toast(<SWUpdateNotification registration={registration} />, {
        duration: Number.POSITIVE_INFINITY,
      })
    },
  })
}

if (!('scrollBehavior' in document.documentElement.style)) {
  // @ts-ignore
  void import('smoothscroll-polyfill').then((mod) => {
    mod.polyfill()
  })
}
